/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowTurnDownRight: {
  name: 'arrow-turn-down-right';
  data: string;
} = {
  name: 'arrow-turn-down-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 2.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 0 .5.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.793 9.5H2A1.5 1.5 0 0 1 .5 8V3a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></svg>`,
};
